import styled from "styled-components";

export const StyledLoader = styled.div`
  position: relative;
  left: -9999px;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  background-color: ${({ theme }) => {
    return theme.colors.green;
  }}
  color : ${({ theme }) => {
    return theme.colors.green;
  }}
  box-shadow: ${({ theme }) => {
    return `9999px 0 0 -5px ${theme.colors.green};`;
  }}
  animation: dotPulse 1.5s infinite linear;
  animation-delay: 0.5s;

  &:before {
    box-shadow: ${({ theme }) => {
      return `9974px 0 0 -20px ${theme.colors.green};`;
    }}
    animation: dotPulseBefore 1.5s infinite linear;
    animation-delay: 0s;
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background-color: ${({ theme }) => {
      return theme.colors.green;
    }}
    color : ${({ theme }) => {
      return theme.colors.green;
    }}
  }

  &:after {
    box-shadow: ${({ theme }) => {
      return `10024px 0 0 -5px ${theme.colors.green};`;
    }}
    animation: dotPulseAfter 1.5s infinite linear;
    animation-delay: 1s;
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background-color: ${({ theme }) => {
      return theme.colors.green;
    }}
    color : ${({ theme }) => {
      return theme.colors.green;
    }}
  }

  @keyframes dotPulseBefore {
    0% {
      box-shadow: ${({ theme }) => {
        return `9974px 0 0 -5px ${theme.colors.green};`;
      }} 
    }
    30% {
      box-shadow: ${({ theme }) => {
        return `9974px 0 0 2px ${theme.colors.green};`;
      }} 
    }
    60%,
    100% {
      box-shadow: ${({ theme }) => {
        return `9974px 0 0 -5px ${theme.colors.green};`;
      }} 
    }
  }

  @keyframes dotPulse {
    0% {
      box-shadow: ${({ theme }) => {
        return `9999px 0 0 -5px ${theme.colors.green};`;
      }}
    }
    30% {
      box-shadow: ${({ theme }) => {
        return `9999px 0 0 2px  ${theme.colors.green};`;
      }}
    }
    60%,
    100% {
      box-shadow: ${({ theme }) => {
        return `9999px 0 0 -5px ${theme.colors.green};`;
      }}
    }
  }

  @keyframes dotPulseAfter {
    0% {
      box-shadow: ${({ theme }) => {
        return `10024px 0 0 -5px ${theme.colors.green};`;
      }}
    }
    30% {
      box-shadow: ${({ theme }) => {
        return `10024px 0 0 2px ${theme.colors.green};`;
      }}
    }
    60%,
    100% {
      box-shadow: ${({ theme }) => {
        return `10024px 0 0 -5px ${theme.colors.green};`;
      }}
    }
  }
`;

export const Container = styled.div`
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;
  width: fit-content;
  height: fit-content;
`;

export const LoaderText = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #e0e0e0;
`;